import { Map } from 'immutable';
import Constants from '../../constants';
import { requestStateReducer } from '../helpers/views';

export const DEFAULT_STATE = Map({});

const acceptAnswerRequest = requestStateReducer(
	[Constants.ACCEPT_ANSWER, Constants.UNACCEPT_ANSWER],
	DEFAULT_STATE,
);

export default acceptAnswerRequest;
